import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Pillar } from '../model/toc.model';
import { DateUtilsService } from '@icullen/utils';

@Component({
  selector: 'document-pillar-toc',
  templateUrl: './pillar-toc.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./pillar-toc.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PillarTocComponent implements OnInit {
  @Input() pillar: Pillar;
  @Input() newIndicatorDays: string;
  @Input() hideTitle = false;

  constructor(public dateService: DateUtilsService) {}

  ngOnInit(): void {
    //console.log('pillar :'+this.pillar);
  }
}
